// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
  --checkboxSize:1.125rem;
  --focusOutlineFF:2px auto Highlight;
  --focusOutline:2px auto -webkit-focus-ring-color;
  --focusOutlineOffset:4px;
  --focusOutlineOffsetFF:2px;
  --inputLineColor:var(--colorGrey40);
  --inputLabelColor:var(--colorGrey40);
  --inputIconWidth:1.875rem;
  --inputBorderWidth:2px;
  --inputEasingFn:ease;
  --inputTransitionTime:0.28s;
  --selectHeight:3rem;
}
.select__item{
    height:3rem;
    padding:0 1rem;
    overflow:hidden;
    text-overflow:ellipsis;
    font-weight:400;
    line-height:3rem;
    white-space:nowrap;
    cursor:pointer;
    border-bottom:0.0625rem solid #f6f7f8;
  }
.select__item:hover,
    .select__item--hover{
      background:#f6f7f8;
    }
.select__item:hover .user-select__user-icon, .select__item--hover .user-select__user-icon{
        color:#206dd2;
      }
.select__item--selected,
    .select__item--selected:hover{
      font-weight:700;
      background:#e5f5ff;
    }
.select__item--thick-border-bottom:not(:last-of-type){
      border-bottom-color:#d4d4d4;
    }
.select--hide-label{
    margin-top:0;
  }
.select--hide-label .select__label{
      display:none;
    }
.select--hide-label .select__value-container{
      margin-top:0;
    }
.select--search-type{

    font-size:1rem;

    line-height:1.5rem;
    height:100%;
    margin-top:0;
  }
.select--search-type .select__value-container{
      min-height:0;
      padding-top:0;
    }
.select--search-type .select__value-container .select__bar{
        display:none;
      }
.select--search-type .select__value-container .select__arrow--down{
        margin-right:0.25rem;
      }
.select--search-type .select__value-container .select__value{
        padding:0.4375rem 0.75rem;
        background-color:#f6f7f8;
        border-radius:0.5rem 0 0 0.5rem;
        top:0;
      }
.select--search-type .select__open-menu-container .select__opened-label{
        padding:0.4375rem 0.75rem;
        background-color:#f6f7f8;
        border-radius:0.5rem 0 0 0.5rem;
      }
.select__button{
    opacity:1;
  }
.select__value{
    padding-left:0.25rem;
  }
.select.input.input--icon .select__button{
      margin-left:1.875rem;
    }
.select.input.input--icon .select__opened-label{
      margin-left:1.875rem;
    }
.select.input.input--icon .select__value{
      padding-left:2.125rem;
    }
.select.input.input--icon .select__label{
      top:0;
      left:1.875rem;
      padding:0.875rem 0 0.4375rem 0;
      font-weight:400;
      color:#707070;
      text-transform:none;
      font-size:1rem;
      line-height:1.5rem;
    }
.select.input.input--icon.select--has-value .select__label,
    .select.input.input--icon.select--menu-open .select__label{
      top:-0.25rem;
      left:0;
      padding:0;
      font-size:0.875rem;
      font-weight:700;
      line-height:1.375rem;
      color:#707070;
      text-transform:uppercase;
      left:0;
    }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
